import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import styles from './HeaderCartEmptyMessage.module.scss';
export const HeaderCartEmptyMessage = ({ message, }) => {
    return (_jsx("div", { className: cx(styles['header__cart-empty-container']), children: _jsx("p", { className: cx(styles['header__cart-empty-text'], 'text-center'), "data-testid": "cat-header-cart-empty-message", children: message }) }));
};
